import React from 'react'
import { Modal, Button } from 'react-bootstrap';

const MessageModal = (props) => {
  return (
    <div className="container">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h2>Thank you for your interest in Pay After Salary System!</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h1></h1>
          <p className="message-body">
            We appreciate the way you like us. But we apologize to say that we
            temporarily closed openining new accounts. We will soon reopen, and
            in that case we will like to have your contact details so that we
            can quickly notify you when we resumed, kindly fill the form below.
            Thank you indeed.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>OK</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default MessageModal